import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { StateShape } from "checkout/ts/redux/store";
import { isTestProcessingMode } from "checkout/ts/utils/environment";
import { LOCALE_LABELS } from "common/locale/labels";
import { ProcessingMode } from "univapay-node";

export const TestEnvironmentBanner = () => {
    const configuration = useSelector((state: StateShape) => state.configuration);
    const {
        params: { hideTestBanner },
    } = useSelector((state: StateShape) => state.application.params);
    const { mode } = configuration?.data || {};
    const { formatMessage } = useIntl();

    const environmentLabel = (() => {
        switch (mode) {
            case ProcessingMode.TEST:
                return formatMessage({ id: LOCALE_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE });
            case ProcessingMode.LIVE_TEST:
                return formatMessage({ id: LOCALE_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE });
            default:
                "";
        }
    })();

    if (hideTestBanner || !isTestProcessingMode(mode)) {
        return null;
    }

    return <div className="test-environment-banner">{environmentLabel}</div>;
};
